// src/components/auth/CambiarContrasenaObligatorio.tsx
// LOGIN-15: bloqueo de la sesión de un admin creado con contraseña temporal
// hasta que la reemplace. Se apoya en el endpoint existente PUT /api/auth/contrasena.
import { useState } from 'react'
import api from '@/services/api'
import { useAuthStore } from '@/store/authStore'
import { mensajeErrorCambioContrasena } from '@/utils/authGuards'
import toast from 'react-hot-toast'

export default function CambiarContrasenaObligatorio() {
  const { requiereCambioPassword, limpiarCambioObligatorio, logout } = useAuthStore()
  const [actual, setActual] = useState('')
  const [nueva, setNueva] = useState('')
  const [confirmar, setConfirmar] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  if (!requiereCambioPassword) return null

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)
    if (nueva !== confirmar) {
      setError('La confirmación no coincide con la nueva contraseña.')
      return
    }
    setLoading(true)
    try {
      await api.put('/api/auth/contrasena', {
        contrasena_actual: actual,
        nueva_contrasena: nueva,
      })
      toast.success('Contraseña actualizada correctamente.')
      limpiarCambioObligatorio()
    } catch (err: any) {
      setError(mensajeErrorCambioContrasena(err.response?.data?.detail))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="fixed inset-0 z-[2000] flex items-center justify-center p-4"
         style={{ background: 'rgba(7,27,63,0.6)' }}>
      <form onSubmit={onSubmit} className="card w-full max-w-md p-6">
        <h2 className="text-lg font-bold mb-1" style={{ color: 'var(--color-text-primary)' }}>
          Cambia tu contraseña temporal
        </h2>
        <p className="text-sm mb-4" style={{ color: 'var(--color-text-secondary)' }}>
          Por seguridad, debes reemplazar la contraseña temporal antes de continuar.
        </p>

        {error && (
          <div className="mb-3 text-sm" style={{ color: 'var(--color-miva-rose)' }}>{error}</div>
        )}

        <input
          className="w-full mb-2 rounded-lg px-3 py-2"
          style={{ background: 'var(--color-surface-900)', border: '1px solid var(--color-border)', color: 'var(--color-text-primary)' }}
          type="password" placeholder="Contraseña actual" autoComplete="current-password"
          value={actual} onChange={(e) => setActual(e.target.value)} required
        />
        <input
          className="w-full mb-2 rounded-lg px-3 py-2"
          style={{ background: 'var(--color-surface-900)', border: '1px solid var(--color-border)', color: 'var(--color-text-primary)' }}
          type="password" placeholder="Nueva contraseña" autoComplete="new-password"
          value={nueva} onChange={(e) => setNueva(e.target.value)} required
        />
        <input
          className="w-full mb-4 rounded-lg px-3 py-2"
          style={{ background: 'var(--color-surface-900)', border: '1px solid var(--color-border)', color: 'var(--color-text-primary)' }}
          type="password" placeholder="Confirmar nueva contraseña" autoComplete="new-password"
          value={confirmar} onChange={(e) => setConfirmar(e.target.value)} required
        />

        <div className="flex justify-between gap-3">
          <button type="button" className="btn btn-ghost btn-sm" onClick={() => logout()}>
            Cerrar sesión
          </button>
          <button type="submit" className="btn btn-primary btn-sm" disabled={loading}>
            {loading ? 'Guardando...' : 'Actualizar contraseña'}
          </button>
        </div>
      </form>
    </div>
  )
}
